var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{staticClass:"grow hidden-sm-and-down",attrs:{"contain":"","max-height":"200","width":"100%","position":"bottom left","src":require('@/assets/buss.png')}})
}
var staticRenderFns = []

export { render, staticRenderFns }